import { ActionTypes } from "../constants/action-types"

const initialState = {
    tutorialTopics:[]

}

export const FetchTutorialTopics = (state=initialState, {type, payload})=>{
switch (type){
    case ActionTypes.FETCH_TUTORIAL_TOPIC: 
    return {...state, tutorialTopics: payload}
    case ActionTypes.DELETE_TUTORIAL_TOPIC:
        return {
          ...state,
          courses: state.tutorialTopics.filter((item, index) => index !== payload)
        }
    default: return state
}

}